import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as IconBottom } from "../../../assets/icons/align-bottom.svg";
import { ReactComponent as IconMiddle } from "../../../assets/icons/align-middle.svg";
import { ReactComponent as IconLeft } from "../../../assets/icons/align-left.svg";
import { ReactComponent as IconRight } from "../../../assets/icons/align-right.svg";
import { ReactComponent as IconTop } from "../../../assets/icons/align-top.svg";
import { ReactComponent as IconCenter } from "../../../assets/icons/align-center.svg";
import { ReactComponent as IconBackward } from "../../../assets/icons/icon_backward.svg";
import { ReactComponent as IconFlipH } from "../../../assets/icons/icon_flip_h.svg";
import { ReactComponent as IconFlipV } from "../../../assets/icons/icon_flip_v.svg";
import { ReactComponent as IconForward } from "../../../assets/icons/icon_forward.svg";
import { ReactComponent as IconBack } from "../../../assets/icons/icon_to_back.svg";
import { ReactComponent as IconFront } from "../../../assets/icons/icon_to_front.svg";
import { wsMoveLayer } from "../../../_actions/webSocketAction";
import { alignObject } from "../../../_utils/common";
import { TldrCustomSidebarIconAction } from "../../common/statelessView";
import {
  StyledAdvEditorToolbarFormatGroup,
  StyledAdvEditorToolbarRow,
} from "../../styled/details/stylesDetails";
import { white } from "../../styled/variable";
import {
  ALIGN_BOTTOM,
  ALIGN_CENTER,
  ALIGN_LEFT,
  ALIGN_MIDDLE,
  ALIGN_RIGHT,
  ALIGN_TOP,
  comboKey1,
  comboKey3,
  LAYER_ORDER_BRING_FORWARD,
  LAYER_ORDER_BRING_TO_FRONT,
  LAYER_ORDER_SEND_BACKWARD,
  LAYER_ORDER_SEND_TO_BACK,
} from "../constants";
import { withTranslation } from "react-i18next";

class QuickCommonLayerActions extends Component {
  move = (action) => {
    const { canvasRef } = this.props;
    canvasRef.handler.move(action);
    this.props.wsMoveLayer(action, this.props.editor.activeElement.id);
  };

  align = (action) => {
    const { activeElement, activeSelection } = this.props.editor;
    if (activeElement.mime) {
      alignObject(action, this.props.canvasRef);
    } else if (activeSelection.mime) {
      this.alignGroupedObject(action);
    }
  };

  alignGroupedObject = (direction) => {
    let group = this.props.canvasRef.handler.canvas.getActiveObject();
    if (!group) {
      return;
    }

    let groupWidth = group.getBoundingRect(true).width;
    let groupHeight = group.getBoundingRect(true).height;
    let scaleXFactor = group.scaleX;
    let scaleYFactor = group.scaleY;

    group.forEachObject((item) => {
      var itemWidth = item.getBoundingRect().width * scaleXFactor;
      var itemHeight = item.getBoundingRect().height * scaleYFactor;

      if (direction === "left") {
        item.set({
          left: -(groupWidth / 2),
          originX: "left",
          originY: "top",
        });
      } else if (direction === "center") {
        item.set({
          left: -itemWidth / 2,
          originX: "left",
          originY: "top",
        });
      } else if (direction === "middle") {
        item.set({
          top: -itemHeight / 2,
          originX: "left",
          originY: "top",
        });
      } else if (direction === "top") {
        item.set({
          top: -groupHeight / 2,
          originX: "left",
          originY: "top",
        });
      } else if (direction === "right") {
        item.set({
          left: groupWidth / 2 - itemWidth,
          originX: "left",
          originY: "top",
        });
      } else if (direction === "bottom") {
        item.set({
          top: groupHeight / 2 - itemHeight,
          originX: "left",
          originY: "top",
        });
      }
    });

    group.forEachObject((item) => {
      group.removeWithUpdate(item).addWithUpdate(item);
    });
    group.setCoords();
    this.props.canvasRef.handler.canvas.renderAll();
    this.props.canvasRef.handler.updatePositions(group);
  };

  render() {
    const { editor, layers, pages, showOrderOptions, showFlipOptions, t } =
      this.props;
    const { activeElement, activePage, activeSelection } = editor;
    const editorFormat = activeElement.format;
    const { id: activePageId } = activePage;
    const { id: activeElementId } = activeElement;
    const { selectedElements } = activeSelection;
    if ((!activePageId || !activeElementId) && !(selectedElements.length > 0)) {
      return <></>;
    }
    const totalLayersInPage = pages[activePageId].layers.length - 1;
    const selectedLayer = layers[activeElementId];

    return (
      <>
        <StyledAdvEditorToolbarRow>
          {showOrderOptions && (
            <StyledAdvEditorToolbarFormatGroup>
              <div className="title">{t("layer.order")}</div>
              <div className="actions">
                <TldrCustomSidebarIconAction
                  disabled={selectedLayer?.order === totalLayersInPage}
                  action={LAYER_ORDER_BRING_TO_FRONT}
                  icon={<IconFront fill={white} />}
                  title={t("context_menu.bring_front")}
                  callback={this.move}
                  shortcutKeys={[comboKey3, "Shift", "]"]}
                />

                <TldrCustomSidebarIconAction
                  disabled={selectedLayer?.order === totalLayersInPage}
                  action={LAYER_ORDER_BRING_FORWARD}
                  icon={<IconForward fill={white} />}
                  title={t("context_menu.brind_forward")}
                  callback={this.move}
                  shortcutKeys={[comboKey1, "]"]}
                />

                <TldrCustomSidebarIconAction
                  disabled={selectedLayer?.order === 0}
                  action={LAYER_ORDER_SEND_BACKWARD}
                  icon={<IconBackward fill={white} />}
                  title={t("context_menu.send_backward")}
                  callback={this.move}
                  shortcutKeys={[comboKey1, "]"]}
                />

                <TldrCustomSidebarIconAction
                  disabled={selectedLayer?.order === 0}
                  action={LAYER_ORDER_SEND_TO_BACK}
                  icon={<IconBack fill={white} />}
                  title={t("context_menu.send_back")}
                  callback={this.move}
                  shortcutKeys={[comboKey3, "Shift", "["]}
                />
              </div>
            </StyledAdvEditorToolbarFormatGroup>
          )}

          {showFlipOptions && (
            <StyledAdvEditorToolbarFormatGroup mb="1rem">
              <div className="title">{t("context_menu.flip")}</div>
              <div className="actions">
                <TldrCustomSidebarIconAction
                  action="flipX"
                  icon={
                    <IconFlipH
                      fill={white}
                      className={editorFormat?.flipX ? "active" : ""}
                    />
                  }
                  title={t("context_menu.flip_horizontal")}
                  callback={this.transform}
                />

                <TldrCustomSidebarIconAction
                  action="flipY"
                  icon={
                    <IconFlipV
                      fill={white}
                      className={editorFormat?.flipY ? "active" : ""}
                    />
                  }
                  title={t("context_menu.flip_vertical")}
                  callback={this.transform}
                />
              </div>
            </StyledAdvEditorToolbarFormatGroup>
          )}
        </StyledAdvEditorToolbarRow>

        <StyledAdvEditorToolbarFormatGroup>
          <div className="title">{t("context_menu.align")}</div>
          <div className="actions">
            <TldrCustomSidebarIconAction
              action={ALIGN_TOP}
              icon={<IconTop fill={white} />}
              title={t("context_menu.top")}
              callback={this.align}
            />

            <TldrCustomSidebarIconAction
              action={ALIGN_MIDDLE}
              icon={<IconMiddle fill={white} />}
              title={t("context_menu.middle")}
              callback={this.align}
            />

            <TldrCustomSidebarIconAction
              action={ALIGN_BOTTOM}
              icon={<IconBottom fill={white} />}
              title={t("context_menu.bottom")}
              callback={this.align}
            />

            <TldrCustomSidebarIconAction
              action={ALIGN_LEFT}
              icon={<IconLeft fill={white} />}
              title={t("context_menu.left")}
              callback={this.align}
            />

            <TldrCustomSidebarIconAction
              action={ALIGN_CENTER}
              icon={<IconCenter fill={white} />}
              title={t("context_menu.center")}
              callback={this.align}
            />

            <TldrCustomSidebarIconAction
              action={ALIGN_RIGHT}
              icon={<IconRight fill={white} />}
              title={t("context_menu.right")}
              callback={this.align}
            />
          </div>
        </StyledAdvEditorToolbarFormatGroup>
      </>
    );
  }

  transform = (action) => {
    const { editor, canvasRef } = this.props;
    const editorFormat = editor.activeElement.format;
    switch (action) {
      case "flipX":
        canvasRef.handler.objectHandler.flipX(!editorFormat.flipX);
        break;
      case "flipY":
        canvasRef.handler.objectHandler.flipY(!editorFormat.flipY);
        break;
      default:
        return;
    }
  };
}

QuickCommonLayerActions.propTypes = {
  editor: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  layers: state.layerstore.layers,
  pages: state.pagestore.pages,
});

const mapDispatchToProps = (dispatch) => ({
  wsMoveLayer: (action, payload) => dispatch(wsMoveLayer(action, payload)),
});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(QuickCommonLayerActions)
);
